import { render, staticRenderFns } from "./getCodeBut.vue?vue&type=template&id=351a30d2&scoped=true&"
import script from "./getCodeBut.vue?vue&type=script&lang=js&"
export * from "./getCodeBut.vue?vue&type=script&lang=js&"
import style0 from "./getCodeBut.vue?vue&type=style&index=0&id=351a30d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a30d2",
  null
  
)

export default component.exports